export default "__VITE_ASSET__Ca$VKoI7__"